import { IRootState } from 'affiny-core/modules/state';
import get from 'lodash/get';

export const selectReceivedVisitsTotal = (
  state: IRootState
): number | undefined => get(state, 'visits.received.meta.total');

export const selectReceivedVisitorIds = (
  state: IRootState,
  limit?: number
): string[] => {
  const visits = get(state, 'visits.received.list');

  if (!visits) {
    return [];
  }

  return limit ? visits.slice(0, limit) : visits;
};

export const selectReceivedVisitsCurrentPage = (state: IRootState): number =>
  state.visits.received.meta.currentPage;
